<template>
  <BModal
    :modal-name="modalName"
    :delegate="delegate"
    width="454px"
    height="auto"
  >
    <BHeightAdjuster>
      <SfLinkBox
        :sf-related-link-info="sfRelatedLinkInfo"
        :sf-exec-sync-btn="sfExecSyncBtn"
        :resync-task-info="resyncTaskInfo"
        @is-loading="updateLoading"
        @modal-close="close"
        @synced="updateSync"
      />
    </BHeightAdjuster>
  </BModal>
</template>

<script lang="ts" setup>
import { inject, ref } from 'vue';
import SfLinkBox from '@/components/organisms/user/general/modal/salesforce/SfStatusModal/SfLinkBox.vue';
import { KEY_OF_MODAL } from '@/injection-keys';

export type TBmodalDelegate = {
  shouldClose?: () => boolean | Promise<boolean>;
  beforeClose?: () => void;
};
type TProps = {
  modalName: string;
  sfRelatedLinkInfo: {
    sfSyncedAt: Date | null,
    sfRelatedLinks: {
      status: string,
      title: string,
      url: string,
      errorMessage: string,
    }[],
  },
  sfExecSyncBtn?: boolean,
  resyncTaskInfo?: {
    id: number,
    callTargetId: number,
    todoType: number,
  },
};
withDefaults(defineProps<TProps>(), {
  sfExecSyncBtn: true,
});
const emit = defineEmits<TEmits>();
type TEmits = (event: 'synced') => void;
const delegate = {
  shouldClose: () => {
    return !isLoading.value;
  },
};
const isLoading = ref(false);
const updateLoading = (result) => {
  isLoading.value = result;
};
const updateSync = () => {
  emit('synced');
};

const modal = inject(KEY_OF_MODAL);
const close = () => {
  modal.hide('sfRelatedLinkModalDetail');
};
</script>
